import {
    APP_INITIALIZER,
    ApplicationConfig, LOCALE_ID,
    provideZoneChangeDetection
} from '@angular/core';
import {provideRouter, withComponentInputBinding} from '@angular/router';

import {routes} from './app.routes';
import {
    AutoRefreshTokenService,
    createInterceptorCondition,
    INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
    IncludeBearerTokenCondition, includeBearerTokenInterceptor,
    provideKeycloak, UserActivityService, withAutoRefreshToken
} from "keycloak-angular";
import {environment} from "../environments/environment";
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi} from "@angular/common/http";
import {ConfirmationService, MessageService} from "primeng/api";
import {httpLoadingInterceptor} from "./interceptors/http-loading.interceptor";
import {provideAnimationsAsync} from "@angular/platform-browser/animations/async";
import {providePrimeNG} from "primeng/config";
import {CpePreset} from "../CpeTheme";
import {initCpePreload, PreloadService} from "./services/app/preload.service";
import {BaseUrlInterceptor} from './interceptors/base-url.interceptor';

const baywaApiCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
    urlPattern: /^https:\/\/api(-staging)?\.baywa-lusy\.com\/.*$/,
    bearerPrefix: 'Bearer'
});
const localhostCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
    urlPattern: /^http:\/\/localhost\/.*$/,
    bearerPrefix: 'Bearer'
})

export const appConfig: ApplicationConfig = {
    providers: [
        {provide: LOCALE_ID, useValue: 'de-LU' },
        provideAnimationsAsync(),
        providePrimeNG({
            theme: {
                preset: CpePreset,
                options: {
                    darkMode: true,
                    darkModeSelector: '.dark'
                }
            },
            ripple: true,
            inputVariant: 'filled'
        }),
        provideZoneChangeDetection({eventCoalescing: true}),
        provideRouter(routes, withComponentInputBinding()),
        provideHttpClient(
            withInterceptorsFromDi(),
            withInterceptors([
                httpLoadingInterceptor,
                includeBearerTokenInterceptor
            ])
        ),
        provideKeycloak({
            config: {
                url: environment.keycloak.url,
                realm: environment.keycloak.realm,
                clientId: environment.keycloak.clientId
            },
            initOptions: {
                onLoad: 'login-required',
                checkLoginIframe: false,
                silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
            },
            features: [
                withAutoRefreshToken({
                    onInactivityTimeout: 'logout',
                    sessionTimeout: 60000
                })
            ],
            providers: [
                AutoRefreshTokenService,
                UserActivityService
            ]
        }),
        {
            provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
            useValue: [baywaApiCondition, localhostCondition]
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: BaseUrlInterceptor,
            multi: true
        },
        ConfirmationService,
        MessageService,
        PreloadService,
        {
            provide: APP_INITIALIZER,
            useFactory: initCpePreload,
            deps: [PreloadService],
            multi: true
        }
    ]
};
